<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path d="m22 12-4-4v3H6V8l-4 4 4 4v-3h12v3l4-4Z" />
  </svg>
</template>

<script>
export default {};
</script>
